export default __webpack_public_path__ + "static/media/noexpl_014_EN.1a3ccce2.png";